<template>
<div id="addDeviceList" class="cb" fillHeight="parent">
	<div class="scrollHide tra-fast fL bdLight-right"
		 :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length*.7+stage.setting.system.autoColumnWidth[1]}"
		 scrollFloatX="false" fillHeight="parent">
		<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
			<div class="w4x"></div>
			<div class="sequence" :title="getLanguageStr('word1984','类型/序号')">
                <span>{{getLanguageStr('word1984','类型/序号')}}</span>
			</div>
		</div>
		<div class="fixedScrollBar scrollY tra-fast" fillHeight="parent" scroll="{'group':'a'}">
			<table>
				<thead class="head-token">
				<tr>
					<th class="w4x"></th>
					<th></th>
				</tr>
				</thead>
				<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
				<tr v-for="(plant,index) in data" :key="index" @click.stop="view(plant,$event)">
					<td class="selectColumn">
						<Checkbox v-model="plant.isSelect" :index="index" @Click="selectData"></Checkbox>
					</td>
					<td class="curP">
                        <div>{{plant.deviceType?getTypeText(plant.deviceType,'deviceType'):'--'}}</div>
						<div class="cSub" :title="plant.deviceSn">
							{{plant.deviceSn}}
						</div>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
    <div class="operate scrollHide" fillHeight="parent" :mode="stage.setting.loc.operateMode">
		<!-- v-show="moreBtnFlag" -->
		<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
			<div class="cb vaM_E">
				<button class="fa fa-angle-double-right hover-c-main" :title="$t('cmd108',['点击展开/收起'])" @click="operateModeChange" type="button"></button>
				<span class="dpIB lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
				<!-- <button class="sizeS mr1x bdSub boxR cField pl05x pr05x hover-primary fR" type="button">{{getLanguageStr('all19','自定义列')}}</button> -->
			</div>
		</div>
		<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="parent" scroll="{'group':'a'}">
			<table>
				<thead class="head-token">
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody class="bdLight-bottom_E textCut_EE">
				<tr v-for="(plant,index) in data" :key="index">
					<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
                        <button type="button" :title="$t('cmd10',['添加'])" @click="addBtn(plant)">
                            <Icon name="add" class="w1x h1x" :sizeBase="'m'"/><br>
                            <span>{{plant.isAdd?$t('cmd10',['添加']):$t('plant_detail149',['已添加'])}}</span>
                        </button>
						<button class="hover-f-main" type="button" :title="getLanguageStr('word1769','电表配置')" v-if="plant.deviceType=='METER'">
                            <Icon name="setting" class="ico"/><br>
                            <span>{{$t('word1769',['电表配置'])}}</span>
                        </button>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div scroll="{'axis':'x'}" fillHeight="parent">
		<div class="tableSys head noSelect b cField bdLight-bottom"
			 :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
			 scrollFloatY="false">
			<div :title="$t('word1460',['通讯状态'])">{{$t('word1460',['通讯状态'])}}</div>
			<div class="sequence" :title="getLanguageStr('word1715','数据更新时间')" @click="$emit('Order','dataUpdateTime',orderDirection)">
				<span>{{getLanguageStr('word1715','数据更新时间')}}</span>
			</div>
		</div>
		<div class="fixedScrollBar scrollY tra-fast" fillHeight="parent" scroll="{'group':'a'}">
			<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
				<thead class="head-token">
                    <tr>
                        <th></th>
                        <th></th>
                    </tr>
				</thead>
				<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
                    <tr v-for="(plant,index) in data" :key="index">
                        <td>
                            <span v-if="plant.connectStatus==null">--</span>
                            <StatusIco v-else :id="plant.connectStatus" :type="'plant'"></StatusIco>
                        </td>
                        <td :title="plant.updateTime?timeFormat(plant.updateTime,'inc','%Y/%m/%d %H:%M:%S'):'--'">
                            <div>{{plant.updateTime?timeFormat(plant.updateTime,'inc','%H:%M:%S'):'--'}}</div>
                            <div class="cSub">{{plant.updateTime?timeFormat(plant.updateTime,'inc','%Y/%m/%d'):'--'}}</div>
                        </td>
                    </tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
</template>
<script>
import {getLanguageStr} from "@/util/language";
import * as lib from "@/util/lib.js";

import StatusIco from "@/components/common/ui/StatusIco.vue";
import Checkbox from "@/components/common/ui/Checkbox.vue";

// import * as clientApi from '@/api/client/clue'
// import {getUserInfo} from '@/util/auth'
// import * as baseApi from '@/api/base'
import {ApiaddTag} from "@/api/maintain/plant/list.js";

export default {
	name: 'PlantList',
	components: {StatusIco,Checkbox},
	props: {
		data: {
			type: Array,
			default: []
		},
		orderBy: {
			type: String,
			default: 'powerStationName'
		},
		orderDirection: {
			type: String,
			default: 'DESC'
		}
	},
	data() {
		return {
			stage,
			floatColumn: ["a", "a"],
			column: ["1", "2", "3"],
			orderDirectioned: this.orderDirection,
			orderByed: this.orderBy,
            lastOrderBy: null,
		}
	},
	methods: {
		timeFormat:lib.timeFormat,
		getLanguageStr,
		getTypeText:lib.getTypeText,
		floatFix:lib.floatFix,
		convertData:lib.convertData,
		operateModeChange:lib.operateModeChange,
		view:function(clue,$e){
			let $td=$($e.target).is("td")? $($e.target):$($e.target).parents("td").first();//定位td层
			let qty=$td.find("label input").length;//获取复选框数量
			if(qty==0){
				this.$emit("view",clue);
			}
		},
		selectData:function(val,index){
			this.$emit("Select",val,index);
		},
		goOrderBy(...args) {
			this.orderByed = args[0]
			if(this.orderByed === this.lastOrderBy) {
				if(this.orderDirectioned === 'desc') {
					this.orderDirectioned = 'asc'
				}else{
					this.orderDirectioned = 'desc'
				}
			}else{
				this.orderDirectioned = 'desc'
			}
			this.lastOrderBy = this.orderByed
			this.$emit('onOrderBy',this.orderDirectioned,this.orderByed)
        },
        addBtn(val){
            console.log(val)
            // this.$set(this.data,'isAdd',true)
        }
		// 特别关注
		// _attention(clue) {
		// 	let userInfo = JSON.parse(getUserInfo())
		// 	let filter = {
		// 		userId: userInfo.userId,
		// 		leadId: clue.id
		// 	}
		// 	let _this = this
		// 	clientApi.leadFollow(filter).then( data => {
		// 		console.log(data);
		// 		_this.$emit('attention',clue)
		// 	}, error => {
		// 		!_.isEmpty(error) && this.$notify(error)
		// 	})
		// },
		//取消关注
		// _cancelAttention(clue) {
		// 	let userInfo = JSON.parse(getUserInfo())
		// 	let filter = {
		// 		userId: userInfo.userId,
		// 		leadId: clue.id
		// 	}
		// 	let _this = this
		// 	clientApi.leadFollowDelete(filter).then( data => {
		// 		_this.$emit('cancelAttention',clue)
		// 	}, error => {
		// 		!_.isEmpty(error) && this.$notify(error)
		// 	})
		// },
		// 编辑
		// edit(clue) {
		// 	this.$emit('edit',clue)
		// }
	},
	mounted() {
        this.lastOrderBy = this.orderByed;
        // lib.fillHeight()
		lib.setScroll($("#addDeviceList [scroll]"));
	}
}
</script>
<style lang="scss" scoped>
$operateMin:4em + 1;
$operateMax:4em * 2 + 1;
.operate{
	>*{width:$operateMax;}
	&[mode]{width:$operateMax;}
	&[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operateMax);}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddDevice/List.vue